import type { CourseOption } from './courseCatalog'

const programmes: Array<[string, string]> = [
  ['B.Tech. Civil Engineering', '4 Years'],
  ['B.Tech. Mechanical Engineering', '4 Years'],
  ['B.Tech. Mechanical (Automobile) Engineering', '4 Years'],
  ['B.Tech. Mechatronics Engineering', '4 Years'],
  ['B.Tech. Aerospace Engineering', '4 Years'],
  ['B.Tech. Electrical Engineering', '4 Years'],
  ['B.Tech. Electrical & Computer Engineering', '4 Years'],
  ['B.Tech. Electronics & Telecommunication Engineering', '4 Years'],
  ['B.Tech. Electronics & Computer Science Engineering', '4 Years'],
  ['B.Tech. Electronics & Electrical Engineering', '4 Years'],
  ['B.Tech. VLSI Design and Technology', '4 Years'],
  ['B.Tech. Computer Science & Engineering', '4 Years'],
  ['B.Tech. Information Technology', '4 Years'],
  ['B.Tech. Chemical Engineering', '4 Years'],
  ['B.Tech. Biotechnology', '4 Years'],
  ['B.Tech. Civil Engineering (Lateral Entry)', '3 Years'],
  ['B.Tech. Mechanical Engineering (Lateral Entry)', '3 Years'],
  ['B.Tech. Mechanical (Automobile Engineering) (Lateral Entry)', '3 Years'],
  ['B.Tech. Electrical Engineering (Lateral Entry)', '3 Years'],
  ['B.Tech. Electronics & Telecommunication Engineering (Lateral Entry)', '3 Years'],
  ['B.Tech. Computer Science & Engineering (Lateral Entry)', '3 Years'],
  ['B.Tech. Information Technology (Lateral Entry)', '3 Years'],
  ['B.Tech. Electronics & Electrical Engineering (Lateral Entry)', '3 Years'],
  ['B.Tech. Mechatronics Engineering (Lateral Entry)', '3 Years'],
  ['B.Tech. Chemical Engineering (Lateral Entry)', '3 Years'],
  ['M.Tech. Electrical Engineering — Power Electronics & Drives', '2 Years'],
  ['M.Tech. Electrical Engineering — Power & Energy System', '2 Years'],
  ['M.Tech. Electrical Engineering — Power System Engineering', '2 Years'],
  ['M.Tech. Computer Science & Engineering', '2 Years'],
  ['M.Tech. Computer Science & Information Security', '2 Years'],
  ['M.Tech. Data Analytics', '2 Years'],
  ['M.Tech. Software Engineering', '2 Years'],
  ['M.Tech. AI & Data Science', '2 Years'],
  ['M.Tech. Internet of Things (IoT)', '2 Years'],
  ['M.Tech. Cybersecurity', '2 Years'],
  ['M.Tech. Electronics & Tele-Communication Engineering — Communication Engineering', '2 Years'],
  ['M.Tech. VLSI Design & Embedded Systems', '2 Years'],
  ['M.Tech. Electronics Engineering — 5G & Next Gen Wireless Technology', '2 Years'],
  ['M.Tech. Electronics Engineering — Automotive Electronics & Software', '2 Years'],
  ['M.Tech. Mechanical Engineering — Manufacturing Processes & Systems', '2 Years'],
  ['M.Tech. Mechanical Engineering — Machine Design', '2 Years'],
  ['M.Tech. Mechanical Engineering — Thermal Engineering', '2 Years'],
  ['M.Tech. Civil Engineering — Construction Engineering & Management', '2 Years'],
  ['M.Tech. Civil Engineering — Structural Engineering', '2 Years'],
  ['M.Tech. Civil Engineering — Geotechnical Engineering', '2 Years'],
  ['M.Tech. Civil Engineering — Water Resources Engineering', '2 Years'],
  ['M.Tech. Civil Engineering — Transportation Engineering', '2 Years'],
  ['M.Tech. Civil Engineering — Environmental Engineering', '2 Years'],
  ['M.Tech. Environmental Engineering', '2 Years'],
  ['B.Tech. & M.Tech. Dual Degree', '5 Years'],
  ['B.Tech. & MBA Dual Degree', '6 Years'],
  ['PG Diploma in Construction Management & Infrastructure Development', '15 Months'],
  ['Ph.D. Engineering/Technology', '3–5 Years'],
]

export const KIIT_COURSE_CATALOG: CourseOption[] = programmes.map(([name, durationYears]) => ({ name, durationYears }))